import DResultsNutrition from './DResultsNutrition'

export default DResultsNutrition
